import clsx from 'clsx'
import React, {useRef} from 'react'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

import useStyles from './styles'

export default function PreviewTrueOrFalseQuestion ({context, question}) {

  const classes = useStyles()
  const {translate, quizQuestions = {}} = context
  const {properties, premise, answer} = question
  const [value, setValue] = React.useState('')
  const premiseText = question.premise.html || ''

  function handleChange (e){
    setValue(e.target.value == 'true')
  }

  return (
    <Box className={clsx(classes.root, "question", "multiple-choice")}>
      <Box className={clsx(classes.premise, "premise")}>
        {premiseText != '' && (<div className="instructions" dangerouslySetInnerHTML={{__html: premiseText}} />)}
        {premiseText == '' && (<Box className={clsx('warning', 'missing-premise')}>{translate('missing-premise')}</Box>)}
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <RadioGroup className="content" value={value} onChange={handleChange}>
          <FormControlLabel value={true} control={<Radio color="primary" checked={answer.value == true}/>} label={translate('true')} />
          <FormControlLabel value={false} control={<Radio color="primary" checked={answer.value == false}/>} label={translate('false')} />
        </RadioGroup>
      </Box>
    </Box>
  )
}
